import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import RowTotalCost from '~/modules/resourcing/components/RowTotalCost';
import RowTotalHours from '~/modules/resourcing/components/RowTotalHours';
import { Decimal, NoDataItem } from '~/modules/common/components';

export const RequestChartRowTotalTooltip = ({
  role,
  roleRate,
  requestedHours,
  allocatedHours,
  requestedCost,
  allocatedCost,
  showAllocationTotalForResourceRequest,
  hideCosts = false
}) => {
  const cost = [requestedCost];

  if (showAllocationTotalForResourceRequest) {
    return hideCosts ? (
      <RowTotalHours
        showAbbreviatedValue={false}
        plannedHours={requestedHours}
        allocatedHours={allocatedHours}
      />
    ) : (
      <>
        <RowTotalHours
          showAbbreviatedValue={false}
          plannedHours={requestedHours}
          allocatedHours={allocatedHours}
        />
        &nbsp;
        <RowTotalCost
          showAbbreviatedValue={false}
          plannedCost={cost}
          allocatedCost={allocatedCost}
        />
      </>
    );
  }

  return (
    <>
      <div>
        <FormattedMessage id="requestChartRowTotalTooltip.totalRequestedHours" />
        {': '}
        <Decimal value={requestedHours} />
      </div>
      {roleRate || roleRate === 0 ? (
        !hideCosts && (
          <>
            <div>
              <FormattedMessage id="requestChartRowTotalTooltip.costRate" />
              :&nbsp;{' '}
              <Decimal
                value={roleRate}
                prefix={`${requestedCost.currencySymbol} `}
              />
              {role && (
                <>
                  {' '}
                  &nbsp;(
                  {role.displayText})
                </>
              )}
            </div>
            <div>
              <FormattedMessage id="requestChartRowTotalTooltip.totalRequestedCost" />
              {': '}
              <Decimal
                value={requestedCost.amount}
                prefix={`${requestedCost.currencySymbol} `}
              />
            </div>
          </>
        )
      ) : (
        <NoDataItem>
          <FormattedMessage id="requestChartRowTotalTooltip.noRoleMessage" />
        </NoDataItem>
      )}
    </>
  );
};

RequestChartRowTotalTooltip.propTypes = {
  role: PropTypes.object,
  roleRate: PropTypes.number,
  requestedCost: PropTypes.object.isRequired,
  allocatedCost: PropTypes.array.isRequired,
  showAllocationTotalForResourceRequest: PropTypes.bool.isRequired,
  requestedHours: PropTypes.number.isRequired,
  allocatedHours: PropTypes.number,
  hideCosts: PropTypes.bool
};

export default RequestChartRowTotalTooltip;
